import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, TextField, Typography } from "@mui/material"
import PaperDraggable from "../../../../../../components/PaperDraggable"
import { useMutation, useQueryClient } from "react-query"
import axiosClient from "../../../../../../lib/axios"
import { enqueueSnackbar } from "notistack"
import { Controller, useForm } from "react-hook-form"

export default function DialogReverterConclusao({
    open,
    handleClose
}: DialogReverterConclusaoProps) {

    const queryClient = useQueryClient();

    const methods = useForm<{ motivo_cancelamento: string }>()

    const { control, handleSubmit } = methods;


    //queries e mutations
    const { mutate: reverterConclusaoExpedicao, isLoading } = useMutation({
        mutationKey: "reverter-conclusao-expedicao",
        mutationFn: ({ id, motivo }: { id: number, motivo: string }) => axiosClient.post("/estoque/expedicao/reverter-conclusao/" + id, {
            motivo_cancelamento: motivo
        }),
        onError: (e) => {
            console.error(e)
            enqueueSnackbar('Erro ao reverter conclusão da expedição', { variant: 'error' });
        },
        onSuccess: () => {
            enqueueSnackbar('Expedição revertida com sucesso', { variant: 'success' });
            queryClient.invalidateQueries("pesquisar-expedicoes");
            queryClient.invalidateQueries("pesquisar-itens-para-expedir");
            handleClose()
        }
    });
    //


    //funções manipuladoras
    const onSubmit = (data: { motivo_cancelamento: string }) => {
        reverterConclusaoExpedicao({ id: open, motivo: data.motivo_cancelamento });
    }
    //

    return (
        <Dialog
            fullWidth
            open={Boolean(open)}
            onClose={handleClose}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            scroll="body"
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                Reverter conclusão da expedição
            </DialogTitle>

            <DialogContent>
                <Box my={1.5}>
                    <Controller
                        name="motivo_cancelamento"
                        control={control}
                        rules={{ required: 'O motivo é obrigatório' }}
                        render={({ field, fieldState: { error, invalid } }) => (
                            <TextField
                                {...field}
                                label="Motivo do cancelamento"
                                multiline
                                minRows={3}
                                fullWidth
                                error={invalid}
                                helperText={error ? error.message : ''}
                            />
                        )}
                    />
                    <Divider sx={{ my: 2 }} />
                    <Typography>O pedido terá a conclusão revertida. Deseja continuar?</Typography>
                </Box>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    autoFocus
                    variant="contained"
                    color="error"
                    onClick={handleSubmit(onSubmit)}
                    disabled={isLoading}
                >
                    {
                        isLoading &&
                        <CircularProgress size={20} sx={{ mr: 1 }} />
                    }
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogReverterConclusaoProps {
    open: number,
    handleClose: () => void
}

//